export const DOMAIN_TYPE = 'page';
